export default function(o){

  var div =
    $('<div>')
    .css({
      margin: '0.3rem',
      display: 'inline-block',
      color: o.colors.yellow,
    })
    .html('/')

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/components/spacer/spacer.js